import React from 'react';
import ButtonGroup from '../button/ButtonGroup';
import classNames from 'classnames';
const LinkGroup = (props) => {
    return (React.createElement(ButtonGroup, { ...props, className: classNames({
            [`link-group`]: true,
            [props.status]: props.status
        }, props.className) }));
};
// @NOTE: withConfigProvider is not necessary because it has been applied to ButtonGroup.
export default LinkGroup;
